import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button, Box } from '@mui/material';

export const RatingDialog = ({
                                 open,
                                 onClose,
                                 feedback,
                                 onFeedbackChange,
                                 onSubmit,
                                 submitting
                             }) => (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
            className: 'glass',
            sx: {
                background: 'rgba(28, 39, 60, 0.4)',
                backdropFilter: 'blur(10px)',
                borderColor: 'rgba(255, 255, 255, 0.1)'
            }
        }}
    >
        <DialogTitle sx={{ color: 'var(--color-secondary)' }}>
            Zusätzliches Feedback (Optional)
        </DialogTitle>
        <DialogContent>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
                <TextField
                    multiline
                    rows={4}
                    variant="outlined"
                    label="Erzähle anderen Spielern, was dir besonders an diesem Quiz gefallen hat"
                    value={feedback}
                    onChange={onFeedbackChange}
                    fullWidth
                    className="input-glow"
                    sx={{
                        '& .MuiInputBase-root': {
                            color: 'var(--color-text-primary)',
                            background: 'rgba(255, 255, 255, 0.05)'
                        },
                        '& .MuiInputLabel-root': {
                            color: 'var(--color-text-secondary)'
                        }
                    }}
                />
            </Box>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} sx={{ color: 'var(--color-text-secondary)' }}>
                Überspringen
            </Button>
            <Button
                onClick={onSubmit}
                variant="contained"
                disabled={submitting}
                className="button-glow"
                sx={{
                    background: 'var(--color-secondary)',
                    color: 'var(--color-text-primary)',
                    '&:hover': {
                        background: 'var(--color-secondary-light)'
                    }
                }}
            >
                Feedback senden
            </Button>
        </DialogActions>
    </Dialog>
);